import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  public commonerrorText = new BehaviorSubject(0);
  public isLoading = new BehaviorSubject(false);
  constructor() { }

  show(error: any) {
    this.commonerrorText.next(error);
    this.isLoading.next(true);
  }

  load(error: any){
    this.commonerrorText.next(error);
  }

  hide() {
    this.isLoading.next(false);
  }
}
